"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productSchema = exports.accountProductSchema = exports.ProductTypeEnum = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const productTypeArray = ['Web chat', 'Text chat', 'Text alerts'];
const productType = [...productTypeArray];
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["WebChat"] = "Web chat";
    ProductTypeEnum["TextChat"] = "Text chat";
    ProductTypeEnum["TextAlerts"] = "Text alerts";
})(ProductTypeEnum || (exports.ProductTypeEnum = ProductTypeEnum = {}));
exports.accountProductSchema = yup_lib_1.default.string().oneOf(productTypeArray).required();
exports.productSchema = yup_lib_1.default.object().shape({
    product: yup_lib_1.default.string().oneOf(productTypeArray).required()
});
